export const ALLERGENS = [
  "glutine",
  "crostacei",
  "uova",
  "pesce",
  "arachidi",
  "soia",
  "latte",
  "frutta a guscio",
  "sedano",
  "senape",
  "sesamo",
  "solfiti",
  "lupini",
  "molluschi",
];

export const UNITS = [
  { value: "g", label: "Grammi (g)" },
  { value: "ml", label: "Millilitri (ml)" },
  { value: "pz", label: "Pezzi (pz)" },
];

export const NUTRITION_FIELDS = [
  { key: "kcal", label: "Energia (kcal)" },
  { key: "protein", label: "Proteine (g)" },
  { key: "carbs", label: "Carboidrati (g)" },
  { key: "sugar", label: "di cui zuccheri (g)" },
  { key: "fat", label: "Grassi (g)" },
  { key: "saturated", label: "di cui saturi (g)" },
  { key: "fiber", label: "Fibre (g)" },
  { key: "salt", label: "Sale (g)" },
];
